import React, { useState, useEffect } from 'react';
import { Empty, Spin, Input, Checkbox, Tooltip } from 'antd';
import { SearchOutlined} from '@ant-design/icons';
import Api from "../../../../api";
import Iconfont from "../../../../components/Iconfont/Iconfont";
import "./index.scss";

let defalutPolicyThemeList = [];
const ResearchReportTree = ({
    researchReportChange
}) => {
    const [searchNav, setSearchNav] = useState([
        {value:"1", label:"所属行业"},
        {value:"2", label:"发布机构"}
    ]);
    const [active, setActive] = useState('1');

    const [treeSpinning, setTreeSpinning] = useState(false);

    const [searchText, setSearchText] = useState('');
    const [searchValue, setSearchValue] = useState('');
    const [listData, seListData] = useState([]);

    const [tips, setTips] = useState('搜索行业');
    const [checkIds, setCheckIds] = useState(['9999']);

    useEffect(() => { 
        if (active === '1') {
            // 所属行业
            setTips('搜索行业');
            getIndustryTree();
        } else {
            // 发布机构
            setTips('搜索机构');
            getInstitutionTree();
        }
    }, [searchText,active])


    const switchMav = (index) => {
        setSearchValue('');
        setSearchText('');
        setActive(index);
        changeId('9999');
        seListData([]);
    }

    // 所属行业
    const getIndustryTree = async() => {
       try {
            setTreeSpinning(true);
            let res = await Api.Knowledge.getIndustryTree({
                data: {
                    name: searchText
                }
            });
            setTreeSpinning(false);
            if(res && res.code === 0 && res.data){
                seListData(res.data);
                // if(!searchText){
                //     changeId(res.data[0]);
                // }
            }
       } catch (error) {
           setTreeSpinning(false);
           seListData([]);
       }
    }

    const getInstitutionTree = async() => {
        try {
            setTreeSpinning(true);
            let res = await Api.Knowledge.getListIssuer({
                data: {
                    name: searchText
                }
            });
            setTreeSpinning(false);
            if(res && res.code === 0 && res.data){
                seListData(res.data);
                // if(!searchText){
                //     changeId(res.data[0]);
                // }
            }
        } catch (error) {
           setTreeSpinning(false);
           seListData([]);
        }
    }

    const changeId = (item, type) => {
        if(active === '1'){
            if(item === '9999'){
                setCheckIds([item]);
                researchReportChange({
                    industryTypeIds: [],
                    issuers:[]
                });
                return false
            }

            let _listData = [...listData]
            _listData.map(items => { 
                if(items.id === item.id){
                    items.open = !items.open;
                }
            })
            seListData(_listData);
            // if(item === '9999'){
            //     setCheckIds([item]);
            //     researchReportChange({
            //         industryTypeIds: [],
            //         issuers:[]
            //     });
            //     return false
            // }
            // // 所属行业
            // let newIds  = [];
            // let _checkIds = checkIds[0] === '9999' ? [] : [...checkIds];
            
            // let ids = [item.id];
            // if(item.children && item.children.length > 0){
            //     item.children.map(items=> { 
            //         ids.push(items.id);
            //     })
            // }
            // if(type){
            //     newIds = [..._checkIds, ...ids];
            // }else{
            //     newIds = _checkIds.filter(item => !ids.includes(item))
            // }

            // if(newIds.length <= 0){
            //     newIds = ['9999']
            // }

            // setCheckIds(newIds);

            // researchReportChange({
            //     industryTypeIds: newIds,
            //     issuers:[]
            // });
            // console.log('newIds', newIds);

        }else if(active === '2'){
            setCheckIds([item]);
            // 发布机构
            researchReportChange({
                industryTypeIds:[],
                issuers: (item === '9999' || item[0] === '9999') ? [] : [item],
            });
        }
        
    }

    const onCheckboxChange = (e, item, parentItem) => { 
        let ids = [item.id];
        let newIds = checkIds[0] === '9999' ? [] : [...checkIds];
        


        if(e.target.checked){
            // 选中
            // 如果同级全部选中，勾选上父级
            newIds.push(item.id);

            // let type = true;
            // parentItem.children.map(items=> { 
            //     if(!newIds.includes(items.id)){
            //         type = false;
            //     }
            // })
            // if(type){
            //     newIds.push(parentItem.id);
            // }
        }else{
            // 取消选中
            // 如果父级选中，取消父级选中
            // if(checkIds.includes(item.parentId)){
            //     ids.push(item.parentId);
            // }
            newIds = checkIds.filter(item => !ids.includes(item))
        }

        if(newIds.length <= 0){
            newIds = ['9999']
        }

        setCheckIds(newIds);


        researchReportChange({
            industryTypeIds: newIds[0] === '9999' ? [] : newIds,
            issuers:[]
        });
        console.log('newIds', newIds);

        console.log(`checked = ${e.target.checked}`);
    };

    const handleChange = (e) => {
        if(!e.target.value){
            setSearchText(e.target.value);
        }
        setSearchValue(e.target.value);
    };

    const handleSearch = () => { 
        setSearchText(searchValue);
    };

    return(
        <div className="researchReportTreeFrameV7">

            <div className="searchNav">
                {searchNav.map((item, index) => (
                    <div className={`searchNavItem ${active === item.value ? 'active' : ''}`} key={item.value} onClick={()=>switchMav(item.value)}>{item.label}</div>
                ))}
            </div>

            <Input
                placeholder={tips}
                prefix={<SearchOutlined />}
                style={{width: '100%',marginBottom: '0.5rem'}}
                allowClear={true}
                onChange={handleChange}
                value={searchValue}
                onPressEnter={handleSearch}
            />

            <div className="scrollBox">
                <Spin spinning={treeSpinning}>
                
                <div key='9999' className={`listItem ${checkIds[0] === '9999' ? 'active':''}`} onClick={()=>changeId('9999')}>全部</div>
                
                {(listData && listData.length > 0) ?
                    listData.map((item, index) => {
                        if(active === '1'){
                            return(
                                <div>
                                    <div key={item.id} className={`listTreeItem ${checkIds.includes(item.id) ? 'active':''}`} onClick={()=>{
                                        changeId(item, !checkIds.includes(item.id))
                                    }}>
                                        <Tooltip title={item.industry}>
                                            <div className="classificationName">{item.industry}</div>
                                        </Tooltip>
                                        <Iconfont type={`${item.open ? 'icon-xiala':'icon-shangjiantou4'}`}/> 
                                    </div>
                                    {item.open&& item.children && item.children.length > 0 && item.children.map((items, index) => { 
                                        return (
                                            <div className="listItemChildren">
                                                <Checkbox 
                                                checked={checkIds.includes(items.id)}
                                                onChange={(e)=>onCheckboxChange(e,items,item)}>{items.industry}</Checkbox>
                                            </div>
                                        )
                                    })}
                                </div>
                            )
                        }else{
                            return(
                                <div key={item} className={`listItem ${checkIds.includes(item) ? 'active':''}`} onClick={()=>changeId(item)}>{item}</div>
                            )
                        }
                    }):
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                }</Spin>
            </div>
            

        </div>
    )
}

export default ResearchReportTree;
